var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { clamp } from '../_internal/data';
import { useSSRLayoutEffect } from '../_internal/ssr';
import { useMergedRef } from '../_internal/useMergedRef';
import { ActionTypes, TooltipVisibilityState, } from './Tooltip.interface';
var INITIAL_STATE = {
    position: { top: 0, left: 0 },
    visibilityState: TooltipVisibilityState.NotInstantiated,
};
var VERTICAL_TRIGGER_MARGIN = 12;
var VERTICAL_SMALL_TRIGGER_MARGIN = 8;
var HORIZONTAL_SCREEN_MARGIN = 4;
var VERTICAL_SCREEN_MARGIN = 4;
export var useTooltip = function (props, ref, customTriggerRef) {
    var tooltipRef = useMergedRef(ref);
    var localTriggerRef = React.useRef(null);
    var triggerRef = customTriggerRef !== null && customTriggerRef !== void 0 ? customTriggerRef : localTriggerRef;
    var getPosition = function () {
        var _a, _b;
        var tooltipDimensions = (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var triggerDimensions = (_b = triggerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (!tooltipDimensions || !triggerDimensions) {
            return { top: 0, left: 0 };
        }
        var left = clamp(triggerDimensions.left +
            (triggerDimensions.width - tooltipDimensions.width) / 2, HORIZONTAL_SCREEN_MARGIN, window.innerWidth - tooltipDimensions.width - HORIZONTAL_SCREEN_MARGIN);
        var top = triggerDimensions.top -
            tooltipDimensions.height -
            (props.small ? VERTICAL_SMALL_TRIGGER_MARGIN : VERTICAL_TRIGGER_MARGIN);
        if (top < VERTICAL_SCREEN_MARGIN) {
            top = triggerDimensions.bottom + VERTICAL_TRIGGER_MARGIN;
        }
        return { top: top, left: left };
    };
    var reducer = function (state, action) {
        switch (action.type) {
            case ActionTypes.SetVisibilityState: {
                return __assign(__assign(__assign({}, state), { visibilityState: action.value }), (action.value === TooltipVisibilityState.Visible
                    ? { position: getPosition() }
                    : {}));
            }
            case ActionTypes.UpdatePosition: {
                return __assign(__assign({}, state), { position: getPosition() });
            }
        }
    };
    var _a = React.useReducer(reducer, INITIAL_STATE), state = _a[0], dispatch = _a[1];
    var visibilityStateRef = React.useRef(state.visibilityState);
    visibilityStateRef.current = state.visibilityState;
    var handleMouseEnter = React.useCallback(function () {
        if (!props.disabled) {
            dispatch({
                type: ActionTypes.SetVisibilityState,
                value: visibilityStateRef.current === TooltipVisibilityState.NotInstantiated
                    ? TooltipVisibilityState.HiddenWaitingToBeVisible
                    : TooltipVisibilityState.Visible,
            });
        }
    }, [props.disabled]);
    var handleMouseLeave = React.useCallback(function () {
        return dispatch({
            type: ActionTypes.SetVisibilityState,
            value: TooltipVisibilityState.HiddenHasBeenVisible,
        });
    }, []);
    useSSRLayoutEffect(function () {
        if (props.disabled) {
            dispatch({
                type: ActionTypes.SetVisibilityState,
                value: TooltipVisibilityState.NotInstantiated,
            });
        }
    }, [props.disabled]);
    useSSRLayoutEffect(function () {
        dispatch({ type: ActionTypes.UpdatePosition });
    }, [props.description, props.title, props.small]);
    React.useEffect(function () {
        if (state.visibilityState === TooltipVisibilityState.HiddenWaitingToBeVisible) {
            dispatch({
                type: ActionTypes.SetVisibilityState,
                value: TooltipVisibilityState.Visible,
            });
        }
    }, [state.visibilityState]);
    return [
        state,
        {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
        },
        { trigger: triggerRef, tooltip: tooltipRef },
    ];
};
//# sourceMappingURL=Tooltip.hooks.js.map